import React, { useState } from 'react';
import './ApplicationPage.css';
import {addDoc, collection} from "firebase/firestore";
import {db} from "../firebase/firebaseConfig";
import { serverTimestamp } from 'firebase/firestore';



export default function ApplicationPage() {
    const [form, setForm] = useState({
        fullName: '',
        email: '',
        courseInterest: '',
        marketingConsent: false,
        errors: {},
        submitted: false,
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const validate = () => {
        const errors = {};
        if (!form.fullName) errors.fullName = 'Full name is required.';
        if (!form.email || !/\S+@\S+\.\S+/.test(form.email)) errors.email = 'Valid email is required.';
        if (!form.courseInterest) errors.courseInterest = 'Please select a course of interest.';
        return errors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validate();
        if (Object.keys(errors).length > 0) {
            setForm((prev) => ({ ...prev, errors }));
            return;
        }

        try {
            await addDoc(collection(db, 'applications'), {
                fullName: form.fullName,
                email: form.email,
                courseInterest: form.courseInterest,
                marketingConsent: form.marketingConsent,
                createdAt: serverTimestamp(),
            });
            setForm({
                fullName: '',
                email: '',
                courseInterest: '',
                marketingConsent: false,
                errors: {},
                submitted: true,
            });
        } catch (err) {
            console.error('Error submitting form:', err);
        }
    };

    return (
        <div className="app-page">
            <h1>Crystal Career Application Form</h1>
            <p>Register your interest and receive updates on courses, scholarships, and open days.</p>
            {form.submitted ? (
                <div className="success-message">Thank you! We’ll keep you updated via email.</div>
            ) : (
                <form onSubmit={handleSubmit} className="app-form">
                    <div className="form-group">
                        <label>Full Name</label>
                        <input
                            type="text"
                            name="fullName"
                            value={form.fullName}
                            onChange={handleChange}
                        />
                        {form.errors.fullName && <span className="error">{form.errors.fullName}</span>}
                    </div>

                    <div className="form-group">
                        <label>Email Address</label>
                        <input
                            type="email"
                            name="email"
                            value={form.email}
                            onChange={handleChange}
                        />
                        {form.errors.email && <span className="error">{form.errors.email}</span>}
                    </div>

                    <div className="form-group">
                        <label>Course of Interest</label>
                        <select name="courseInterest" value={form.courseInterest} onChange={handleChange}>
                            <option value="">-- Select a course --</option>
                            <option value="SIA Courses">SIA Courses</option>
                            <option value="Facility Management Courses">Facility Management Courses</option>
                            <option value="Professional Plumbing">Professional Plumbing</option>
                            <option value="Adult Career Booster">Adult Career Booster</option>
                            <option value="JavaScript Essentials">JavaScript Essentials</option>
                            <option value="Java Programming">Java Programming</option>
                            <option value="C++ Programming">C++ Programming</option>
                            <option value="Python Programming">Python Programming</option>
                            <option value="Web Development">Web Development</option>
                            <option value="Software Testing">Software Testing</option>
                            <option value="MySQL for Database Administrator">MySQL for Database Administrator</option>
                            <option value="PostgreSQL for Database Administrator">PostgreSQL for Database Administrator</option>
                            <option value="Other">Other</option>
                        </select>
                        {form.errors.courseInterest && <span className="error">{form.errors.courseInterest}</span>}
                    </div>

                    <div className="form-group">
                        <label htmlFor="nationality">Nationality</label>
                        <input
                            type="text"
                            id="nationality"
                            name="nationality"
                            value={form.nationality}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="residenceCountry">Country of Residence</label>
                        <input
                            type="text"
                            id="residenceCountry"
                            name="residenceCountry"
                            value={form.residenceCountry}
                            onChange={handleChange}
                            required
                        />
                    </div>

                    <div className="form-group checkbox">
                        <label>
                            <input
                                type="checkbox"
                                name="marketingConsent"
                                checked={form.marketingConsent}
                                onChange={handleChange}
                            />
                            I would like to receive marketing information by email.
                        </label>
                    </div>

                    <button type="submit" className="submit-btn">Register Interest</button>
                </form>
            )}
        </div>
    );
}
